import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { PainPoints } from './components/PainPoints';
import { ProductIntro } from './components/ProductIntro';
import { WhatsIncluded } from './components/WhatsIncluded';
import { PriceAnchor } from './components/PriceAnchor';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { OfferStack } from './components/OfferStack';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MobileStickyCTA } from './components/MobileStickyCTA';
export function App() {
  return <div className="min-h-screen w-full flex flex-col font-sans" data-id="element-0">
      <UrgencyBanner data-id="element-1" />
      <main className="flex-grow pb-24 md:pb-0" data-id="element-2">
        <Hero data-id="element-3" />
        <TrustStrip data-id="element-4" />
        <PainPoints data-id="element-5" />
        <ProductIntro data-id="element-6" />
        <WhatsIncluded data-id="element-7" />
        <Bonuses data-id="element-8" />
        <PriceAnchor data-id="element-9" />
        <Testimonials data-id="element-10" />
        <OfferStack data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
      <MobileStickyCTA data-id="element-16" />
    </div>;
}